module.exports = __webpack_public_path__ + "01_very_short_brown.fff2ae86.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_very_short_brown.png
// module id = EkxZ
// module chunks = 0